import React from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import Spinner from '../Spinner';

const PageContent = (props) => {
	return (
		<Card className={props.cardClass}>
			<Card.Body>
				<div className="header-container">
					<Card.Title><h4>{props.title}</h4></Card.Title>
					<p className="text-muted">{props.subtitle}</p>
				</div>
				{ props.errors && 
          (<div className="alert alert-danger" role="alert">
            {props.errors}
          </div>)
        }
        <form onSubmit={props.handleSubmit} className={props.formClassNames}>
					<div className="card-content">{props.children}</div>
	        {props.showFooter &&
		        (<Row>
				      <Col md={12}>
				        <div className="footer-btn-container">
				        	{ props.hasBackBtn &&
				          	(<Button 
				            	className="btn back-btn"
				            	onClick={() => props.goBack()}><span className="arrowLeft"><FaArrowLeft /></span><span className="left-btn-text">Terug</span></Button>
				            )
				          }	
				          { props.hasCustomizableBackButton &&
				        		(<Button 
	                    className="btn back-btn"
	                    onClick={() => {
	                      props.goBack()
	                    }}>{props.backBtnState ? <Spinner color="text-blue"/> : (<><span className="arrowLeft"><FaArrowLeft /></span><span className="left-btn-text">Terug</span></>)}</Button>
	                  )
				        	}
				          { props.hasNextBtn && 
				          	(<Button 
				            	className="btn continue-btn"
				            	onClick={() => props.moveNext()}>{props.buttonState ? <Spinner /> : (<><span className="right-btn-text">Verder</span> <span className="arrowRight"><FaArrowRight /></span></>)}</Button>
				            )
				        	}
				          { props.hasSubmitBtn && 
				          	(<Button
			                type="submit" 
			                className="btn continue-btn"
			                disabled={props.submitting}>{props.buttonState ? <Spinner /> : (<><span className="right-btn-text">Verder</span> <span className="arrowRight"><FaArrowRight /></span></>)}</Button>
				          	)
				        	}
				        	{ props.hasCustomizableNextButton &&
				        		(<Button 
	                    className={`btn continue-btn ${props.btnDisabled ? 'disabled-btn' : ''}`}
	                    disabled={props.btnDisabled}
	                    onClick={() => {
	                      props.moveNext()
	                    }}>{props.buttonState ? <Spinner /> : (<><span className="right-btn-text">Verder</span> <span className="arrowRight"><FaArrowRight /></span></>)}</Button>
	                  )
				        	}
				        </div>
				      </Col>
			      </Row>)
		      }
	      </form>
			</Card.Body>
		</Card>
	);
}

export default PageContent;
